var RobotChat = function(conferenceId, endpoint) {
    this.CLASS_USER = 'right';
    this.CLASS_BOT  = 'bot';
    this.WAITING    = '<div class="dot-pulse"></div>';
    this.TERMS_LINK = 'https://portfoliocsoport.hu/info/adatkezelesi-tajekoztato-a-portfoliohu-honlap-regisztralt-felhasznaloi-reszere';

    this.waitingForAnswer = false;
    this.init();
    this.conferenceId = conferenceId;
    this.endpoint = endpoint;
};

RobotChat.prototype.init = function()
{
    const main = $('body');
    const self = this;
    $('<div class="robotchat-icon"><i></i><span>Segíthetünk?</span></div>')
        .on('click', function(){
            self.hideIcon();
            self.showWindow();
        })
        .appendTo(main);
};

RobotChat.prototype.hideIcon = function()
{
    $('.robotchat-icon').hide();
};

RobotChat.prototype.showWindow = function()
{
    if (this.chatWindow) {
        this.input.trigger('focus');
        this.chatWindow.show();
        return;
    }
    const main = $('body');
    this.chatWindow = $(`<div class="card direct-chat direct-chat-primary"></div>`).appendTo(main);
    this.chatHeader = this.createHeader().appendTo(this.chatWindow);
    this.chatBody   = this.createBody().appendTo(this.chatWindow);
    this.chatFooter = this.createFooter().appendTo(this.chatWindow);

    this.messages = $('.direct-chat-messages', this.chatBody);
};

RobotChat.prototype.createHeader = function()
{
    const result = $(`<div class="card-header">
                          <h3 class="card-title">Felhasználói támogatás</h3>
                          <div class="card-tools"></div>
                      </div>`);

    const self = this;
    $(`<button type="button" class="btn btn-tool">
           <i class="icon-close"></i>
       </button>`)
           .appendTo(result.find('.card-tools'))
           .on('click', function(){
               self.hide();
           });

    return result;
};

RobotChat.prototype.createBody = function()
{
    const result = $(`<div class="card-body py-2">
                        <div class="direct-chat-messages">
                            <label>
                                <div><span class="weight-600">Üdvözlöm!</span><br>Én a Portfolio robot asszisztense vagyok. A csevegés megkezdése előtt, kérem, fogadja el az adatvédelmi tájékoztatónkat.</div>
                                <div><input type="checkbox" id="robotchat-terms"> Az <a href="${this.TERMS_LINK}" target="_blank" style="color: var(--accent_02);">adatvédelmi irányelveket</a> elfogadom, és megértettem, hogy az adataim tárolása a támogatási élmény optimalizálása érdekében történik.</div>
                            </label>
                        </div>
                    </div>`);

    const self = this;
    result.find('[type="checkbox"')
          .on('click', function(){
               self.chatFooter.find('.site-btn').prop('disabled', !$(this).is(':checked'));
          });
    return result;
};

RobotChat.prototype.createFooter = function()
{
    const result = $(`<div class="card-footer pb-3"></div>`);

    const self = this;
    $(`<button type="button" class="site-btn site-btn-orange w-100" disabled="disabled">Csevegés indítása</button>`)
        .appendTo(result)
        .on('click', function() {
            $(this).remove();
            self.addMessageInput();
            self.clear();
        });
    return result;
};

RobotChat.prototype.addMessageInput = function()
{
    const inputGroup = $('<div class="input-group"></div>').appendTo(this.chatFooter);

    const self = this;
    this.input = $(`<input type="text" id="message" placeholder="Ide írja az üzenetét..." class="form-control" maxlength="200">`)
                       .appendTo(inputGroup)
                       .on('keydown', function(e){
                           if (e.key === 'Enter') {
                               self.send();
                           }
                        })
                        .trigger('focus');
    const icon = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 7.303 7.303" fill="currentColor"><path d="M7.06 0a.25.25 0 0 0-.127.04L.165 2.409a.247.247 0 0 0-.019.458L3.124 4.19l1.323 2.978a.247.247 0 0 0 .46-.019L7.273.381a.25.25 0 0 0-.032-.309A.25.25 0 0 0 7.06 0zm-.944.849-2.86 2.86-2.34-1.04zm.35.349-1.82 5.2-1.04-2.34z"/></svg>';

    $(`<button type="button" class="btn btn-sm btn-send">${icon}</button>`)
        .appendTo(inputGroup)
        .on('click', function(){
            self.send();
        });
};

RobotChat.prototype.clear = function()
{
    this.messages.empty();
    this.appendMessage('Üdvözlöm! Miben segíthetek?', this.CLASS_BOT);
};

RobotChat.prototype.hide = function()
{
    this.chatWindow.hide();
    $('.robotchat-icon').show();
};

RobotChat.prototype.send = function()
{
    if (this.waitingForAnswer) {
        return;
    }
    const message = this.input.val();
    if (message == '') {
        return;
    }
    this.input.val(null);
    this.appendMessage(message, this.CLASS_USER);
    this.appendMessage(this.WAITING, this.CLASS_BOT);
    this.waitingForAnswer = true;

    const self = this;
    $.ajax({
        url     : this.endpoint,
        method  : 'POST',
        cache   : false,
        data    : {
            conference_id: this.conferenceId,
            message      : message,
            _token: $('meta[name="_token"]').attr('content')
        },
        success : function(response) {
            if (response.answer) {
                self.replaceBotAnswer(response.answer);
            }
        },
        complete: function(){
            self.waitingForAnswer = false;
        }
    });
};

RobotChat.prototype.appendMessage = function(message, className)
{
    this.messages.append(`<div class="direct-chat-msg ${className}"><div class="direct-chat-text">${message}</div></div>`);
    this.messages.scrollTop(this.messages[0].scrollHeight);
};

RobotChat.prototype.replaceBotAnswer = function(message)
{
    const lastBotMessage = $(`.direct-chat-msg.${this.CLASS_BOT}`, this.messages).last();
    if (lastBotMessage.hasClass('answered')) {
        return;
    }
    lastBotMessage.addClass('answered')
                    .find('.direct-chat-text')
                    .html(message);
}

module.exports = RobotChat;
